import type { NodeProps } from "reactflow";
import type { MapViewEntity } from "@/lib/core/schemas/map-view";

export type BlockedTileNodeData = { entity: MapViewEntity };

export const BlockedTileNode = ({ data }: NodeProps<BlockedTileNodeData>) => {
  const { entity } = data;
  return (
    <div
      className="h-10 w-10 bg-stone-700"
      data-entity-id={entity.id}
      title={`${entity.name} (blocks movement)`}
    />
  );
};
